import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useServiceWorkerUpdate } from '@/hooks/use-service-worker-update';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Banner displayed when a new version of the app is available.
 * Allows the user to reload the page to apply the update.
 * Renders nothing when there is no update.
 */
export const UpdateBanner: React.FC = () => {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();

  if (!updateAvailable) return null;

  return (
    <Card className="rounded-none border-x-0 border-t-0 bg-primary text-primary-foreground">
      <CardContent className="flex items-center justify-between gap-4 py-3 px-4">
        <div className="flex items-center gap-3 min-w-0">
          <RefreshCw className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            A new version of SYFO is available.
          </p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={applyUpdate}
          className="flex-shrink-0 cursor-pointer"
        >
          Reload
        </Button>
      </CardContent>
    </Card>
  );
};

export default UpdateBanner;
